module.exports = __webpack_public_path__ + "static/media/ercros@3x.14557222.jpg";